module.exports = __webpack_public_path__ + "img/img-depoimento-3-mobile.e6f04c81.png";